import { Outlet } from 'react-router';

/**
 * Wraps all unauthenticated routes (login, register, forgot-password, verify-email, social callback).
 *
 * Renders once at the layout level:
 *  - Solid dark surface (`bg-background` / --background) so network art reads on brand charcoal, not steel-blue wash
 *  - network-bg-desktop.png (hidden on mobile) / network-bg-mobile.png (mobile only)
 *  - network-face-bg-desktop.png positioned bottom-right (desktop only)
 *
 * Forces the `.dark` class so Tailwind dark: variants apply to all form elements
 * inside the auth pages, regardless of the user's theme preference.
 */
export function PublicLayout() {
  return (
    <div className="dark relative min-h-screen overflow-hidden bg-background">
      {/* Network bg — desktop */}
      <div
        className="pointer-events-none absolute inset-0 hidden bg-cover bg-center opacity-[0.2] sm:block"
        style={{ backgroundImage: "url('/network-bg-desktop.png')" }}
        aria-hidden="true"
      />
      {/* Network bg — mobile */}
      <div
        className="pointer-events-none absolute inset-0 bg-cover bg-center opacity-[0.2] sm:hidden"
        style={{ backgroundImage: "url('/network-bg-mobile.png')" }}
        aria-hidden="true"
      />
      {/* Face illustration — desktop only, anchored bottom-right */}
      <div
        className="pointer-events-none absolute bottom-0 right-0 hidden h-[80vh] w-[50vw] bg-contain bg-right-bottom bg-no-repeat opacity-[0.35] lg:block"
        style={{ backgroundImage: "url('/network-face-bg-desktop.png')" }}
        aria-hidden="true"
      />

      {/* Page content — centred vertically and horizontally */}
      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-4 py-12">
        <Outlet />
      </div>
    </div>
  );
}
